import {
  FaPizzaSlice,
  FaHamburger,
  FaCoffee,
  FaFish,
  FaIceCream,
} from "react-icons/fa";

import {
  GiChickenOven,
  GiFruitBowl,
  GiMeal,
  GiCupcake,
} from "react-icons/gi";

import { MdRestaurant } from "react-icons/md";
import { TbMilk } from "react-icons/tb";
import { FaBottleWater } from "react-icons/fa6";

const recommendedIcons = {
  Biryani: <MdRestaurant />,
  Meals: <GiMeal />,
  Idli: <GiMeal />,
  Dosa: <GiMeal />,
  Vada: <GiMeal />,
  Poori: <GiMeal />,
  Paratha: <GiMeal />,
  Pizza: <FaPizzaSlice />,
  Burger: <FaHamburger />,
  Sandwich: <FaHamburger />,
  Chicken: <GiChickenOven />,
  Mutton: <GiChickenOven />,
  Fish: <FaFish />,
  Seafood: <FaFish />,
  Chinese: <GiMeal />,
  Noodles: <GiMeal />,
  "Fried Rice": <GiMeal />,
  Momos: <GiMeal />,
  Cake: <GiCupcake />,
  Pastry: <GiCupcake />,
  Coffee: <FaCoffee />,
  Tea: <FaCoffee />,
  Juice: <FaBottleWater />,
  Milkshake: <TbMilk />,
  "Ice Cream": <FaIceCream />,
  Rice: <GiMeal />,
  Oil: <FaBottleWater />,
  Vegetables: <GiFruitBowl />,
  Fruits: <GiFruitBowl />,
  Groceries: <GiFruitBowl />,
};

export default recommendedIcons;